import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../../../components/Common/UI/Button';
import Icons from '../../../../../components/Common/Icons/Icons';
import { cn } from '../../../../../utils/styles';

interface INavItem {
  id: string;
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  prefix?: string;
  path: string;
}

const people = ['Karen Client', 'Brandon Adams', 'Ben Chan'];

function NotificationSidebar() {
  const navItems: INavItem[] = useMemo(
    () => [
      {
        id: '1',
        icon: <Icons.Inbox />,
        label: 'Inbox',
        prefix: '123',
        active: true,
        path: '/guidance/notifications',
      },
      {
        id: '2',
        icon: <Icons.Star />,
        label: 'Starred',
        path: '',
      },
      {
        id: '3',
        icon: <Icons.Timer />,
        label: 'Snoozed',
        path: '',
      },
      {
        id: '4',
        icon: <Icons.Send />,
        label: 'Send',
        path: '',
      },
      {
        id: '5',
        icon: <Icons.File />,
        label: 'Drafts',
        prefix: '2',
        path: '',
      },
      {
        id: '6',
        icon: <Icons.ArrowRight className="rotate-90 !h-[20px] !w-[20px]" />,
        label: 'More',
        path: '',
      },
    ],
    [],
  );

  return (
    <div>
      <Button
        className="ml-[20px] rounded-[50px] h-[54px] p-[15px] !bg-[#6D71F8] !text-white hover:opacity-80
            gap-[10px] min-w-[190px] text-[18px]"
      >
        <Icons.PencilEdit className="w-[19px] h-[19px]" />
        Compose
      </Button>
      <div className="my-[10px] grid gap-[10px]">
        {navItems.map(el => (
          <Link
            to={el.path}
            key={el.id}
            className={cn(
              'px-[20px] py-[8px] flex gap-[10px] items-center relative text-addition11 text-[18px] ' +
                '[&_svg]:w-[18px] [&_svg]:h-[18px] justify-between',
              {
                // eslint-disable-next-line max-len
                'before:absolute before:w-full before:rounded-tr-[50px] before:bg-[#6D71F81A] before:h-full before:rounded-br-[50px] before:left-0 font-bold':
                  el.active,
              },
            )}
          >
            <div className="flex items-center gap-[10px]">
              {el.icon}
              <div className="flex justify-between">{el.label}</div>
            </div>
            <div className={cn('opacity-50 font-normal', { 'opacity-100 font-medium': el.active })}>{el.prefix}</div>
          </Link>
        ))}
      </div>
      <div>
        <div
          className="bg-addition11-5 border-t font-medium text-addition11-30 px-[20px] py-[5px] flex
            gap-[10px] items-center mb-[20px]"
        >
          <Icons.Search className="[&_path]:fill-addition11-30" />
          <div>Search people...</div>
        </div>
        <div className="pl-[50px] grid gap-[10px] text-addition11 text-[18px]">
          {people.map(el => (
            <div key={el}>{el}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NotificationSidebar;
